import {QuadrangleVertex} from '../../abstract-units';
import {BoxEdge} from '../../edge';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {BOTTOM_EDGE_CELL_AREA_DEF} from './bottom-edge';
import {CENTER_CELL_AREA_DEF} from './center';

export const BOTTOM_SIDE_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.SIDE,
    boxEdge: BoxEdge.BOTTOM,
    vertices: [
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_LEFT], // TOP_LEFT
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_RIGHT], // TOP_RIGHT
        BOTTOM_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_LEFT], // BOTTOM_LEFT
        BOTTOM_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_RIGHT] // BOTTOM_RIGHT
    ]
};
